export interface ActivityTarget {
  module: string;
  doctype: string;
}

const GENERIC_ACCOUNTING_INVOICE_ALIASES: ActivityTarget[] = [
  { module: "accounting", doctype: "invoice" },
  { module: "accounting", doctype: "invoices" },
];

const ACCOUNTING_CREDIT_NOTE_ALIASES: ActivityTarget[] = [
  { module: "accounting", doctype: "credit_note" },
  { module: "accounting", doctype: "credit-note" },
  { module: "accounting", doctype: "credit-notes" },
];

const ACCOUNTING_DEBIT_NOTE_ALIASES: ActivityTarget[] = [
  { module: "accounting", doctype: "debit_note" },
  { module: "accounting", doctype: "debit-note" },
  { module: "accounting", doctype: "debit-notes" },
];

const ACCOUNTING_CREDIT_DEBIT_NOTE_ALIASES: ActivityTarget[] = [
  { module: "accounting", doctype: "credit_debit_note" },
  { module: "accounting", doctype: "credit-debit-note" },
  { module: "accounting", doctype: "credit_debit_notes" },
  { module: "accounting", doctype: "credit-debit-notes" },
];

const CANONICAL_TARGETS: Record<string, ActivityTarget> = {
  "accounting/payment": { module: "accounting", doctype: "payment" },
  "accounting/payments": { module: "accounting", doctype: "payment" },
  "accounting/receipt": { module: "accounting", doctype: "receipt" },
  "accounting/receipts": { module: "accounting", doctype: "receipt" },
  "marketing/posts": { module: "marketing", doctype: "content-posts" },
  "marketing/targets": { module: "marketing", doctype: "post-targets" },
};

const LEGACY_INVOICE_ALIASES: Record<string, ActivityTarget[]> = {
  "sales/sales_invoice": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    { module: "accounting", doctype: "sales_invoice" },
    { module: "accounting", doctype: "sales-invoice" },
    { module: "accounting", doctype: "sales-invoices" },
  ],
  "purchase/purchase_invoice": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    { module: "accounting", doctype: "purchase_invoice" },
    { module: "accounting", doctype: "purchase-invoice" },
    { module: "accounting", doctype: "purchase-invoices" },
  ],
  "sales/credit_note": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    ...ACCOUNTING_CREDIT_NOTE_ALIASES,
    ...ACCOUNTING_CREDIT_DEBIT_NOTE_ALIASES,
  ],
  "purchase/credit_note": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    { module: "accounting", doctype: "purchase_credit_note" },
    { module: "accounting", doctype: "purchase-credit-note" },
    { module: "accounting", doctype: "purchase-credit-notes" },
    ...ACCOUNTING_CREDIT_NOTE_ALIASES,
    ...ACCOUNTING_CREDIT_DEBIT_NOTE_ALIASES,
  ],
  "sales/sales_debit_note": [
    { module: "sales", doctype: "debit_note" },
    { module: "sales", doctype: "debit-note" },
    { module: "sales", doctype: "debit-notes" },
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    { module: "accounting", doctype: "sales_debit_note" },
    { module: "accounting", doctype: "sales-debit-note" },
    { module: "accounting", doctype: "sales-debit-notes" },
    ...ACCOUNTING_DEBIT_NOTE_ALIASES,
    ...ACCOUNTING_CREDIT_DEBIT_NOTE_ALIASES,
  ],
  "sales/debit_note": [
    { module: "sales", doctype: "sales_debit_note" },
    { module: "sales", doctype: "sales-debit-note" },
    { module: "sales", doctype: "sales-debit-notes" },
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    { module: "accounting", doctype: "sales_debit_note" },
    { module: "accounting", doctype: "sales-debit-note" },
    { module: "accounting", doctype: "sales-debit-notes" },
    ...ACCOUNTING_DEBIT_NOTE_ALIASES,
    ...ACCOUNTING_CREDIT_DEBIT_NOTE_ALIASES,
  ],
  "purchase/debit_note": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    { module: "accounting", doctype: "purchase_debit_note" },
    { module: "accounting", doctype: "purchase-debit-note" },
    { module: "accounting", doctype: "purchase-debit-notes" },
    ...ACCOUNTING_DEBIT_NOTE_ALIASES,
    ...ACCOUNTING_CREDIT_DEBIT_NOTE_ALIASES,
  ],
  "accounting/sales_invoice": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    { module: "sales", doctype: "sales_invoice" },
    { module: "sales", doctype: "sales-invoice" },
    { module: "sales", doctype: "sales-invoices" },
  ],
  "accounting/purchase_invoice": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    { module: "purchase", doctype: "purchase_invoice" },
    { module: "purchase", doctype: "purchase-invoice" },
    { module: "purchase", doctype: "purchase-invoices" },
  ],
  "accounting/credit_note": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    { module: "sales", doctype: "credit_note" },
    { module: "sales", doctype: "credit-note" },
    { module: "sales", doctype: "credit-notes" },
    { module: "purchase", doctype: "credit_note" },
    { module: "purchase", doctype: "credit-note" },
    { module: "purchase", doctype: "credit-notes" },
    { module: "accounting", doctype: "purchase_credit_note" },
    { module: "accounting", doctype: "purchase-credit-note" },
    { module: "accounting", doctype: "purchase-credit-notes" },
    ...ACCOUNTING_CREDIT_DEBIT_NOTE_ALIASES,
  ],
  "accounting/purchase_credit_note": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    ...ACCOUNTING_CREDIT_NOTE_ALIASES,
    { module: "purchase", doctype: "credit_note" },
    { module: "purchase", doctype: "credit-note" },
    { module: "purchase", doctype: "credit-notes" },
    ...ACCOUNTING_CREDIT_DEBIT_NOTE_ALIASES,
  ],
  "accounting/sales_debit_note": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    ...ACCOUNTING_DEBIT_NOTE_ALIASES,
    { module: "sales", doctype: "sales_debit_note" },
    { module: "sales", doctype: "sales-debit-note" },
    { module: "sales", doctype: "sales-debit-notes" },
    { module: "sales", doctype: "debit_note" },
    { module: "sales", doctype: "debit-note" },
    { module: "sales", doctype: "debit-notes" },
    ...ACCOUNTING_CREDIT_DEBIT_NOTE_ALIASES,
  ],
  "accounting/purchase_debit_note": [
    ...GENERIC_ACCOUNTING_INVOICE_ALIASES,
    ...ACCOUNTING_DEBIT_NOTE_ALIASES,
    { module: "purchase", doctype: "debit_note" },
    { module: "purchase", doctype: "debit-note" },
    { module: "purchase", doctype: "debit-notes" },
    ...ACCOUNTING_CREDIT_DEBIT_NOTE_ALIASES,
  ],
};

const DOCUMENT_ALIASES: Record<string, ActivityTarget[]> = {
  ...LEGACY_INVOICE_ALIASES,
  "accounting/receipt": [
    { module: "accounting", doctype: "payment" },
    { module: "accounting", doctype: "payments" },
    { module: "accounting", doctype: "receipts" },
    { module: "accounting", doctype: "payment_receipt" },
    { module: "accounting", doctype: "payment-receipt" },
    { module: "accounting", doctype: "payment_receipts" },
    { module: "accounting", doctype: "payment-receipts" },
    { module: "car-rental", doctype: "receipt" },
    { module: "car-rental", doctype: "receipts" },
  ],
  "accounting/payment": [
    { module: "accounting", doctype: "payments" },
    { module: "accounting", doctype: "payment_receipt" },
    { module: "accounting", doctype: "payment-receipt" },
    { module: "accounting", doctype: "payment_receipts" },
    { module: "accounting", doctype: "payment-receipts" },
    { module: "accounting", doctype: "payment-voucher" },
    { module: "accounting", doctype: "payment-vouchers" },
    { module: "car-rental", doctype: "payment" },
    { module: "car-rental", doctype: "payments" },
  ],
  "car-rental/booking": [
    { module: "car-rental", doctype: "booking-receipts" },
    { module: "car-rental", doctype: "booking_receipts" },
    { module: "car-rental", doctype: "booking-receipt" },
    { module: "car-rental", doctype: "booking_receipt" },
  ],
};

export function canonicalizeActivityTarget(
  target: ActivityTarget
): ActivityTarget {
  const key = `${target.module}/${normalizeDoctype(target.doctype)}`;
  return CANONICAL_TARGETS[key] ?? target;
}

export function resolveSameModuleTargetAliases(
  target: ActivityTarget
): ActivityTarget[] {
  const canonical = canonicalizeActivityTarget(target);
  const candidates: ActivityTarget[] = [];
  const add = (candidate: ActivityTarget) => {
    if (!candidate.module || !candidate.doctype) return;
    if (candidate.module !== canonical.module) return;
    if (
      candidates.some(
        (t) => t.module === candidate.module && t.doctype === candidate.doctype
      )
    ) {
      return;
    }
    candidates.push(candidate);
  };

  add(canonical);
  add(target);
  for (const doctype of [
    ...doctypeVariants(canonical.doctype),
    ...doctypeVariants(target.doctype),
  ]) {
    add({ module: canonical.module, doctype });
  }

  return candidates;
}

export function resolveActivityTargetAliases(
  target: ActivityTarget
): ActivityTarget[] {
  const canonical = canonicalizeActivityTarget(target);
  const candidates: ActivityTarget[] = [];
  const add = (candidate: ActivityTarget) => {
    if (!candidate.module || !candidate.doctype) return;
    if (
      candidates.some(
        (t) => t.module === candidate.module && t.doctype === candidate.doctype
      )
    ) {
      return;
    }
    candidates.push(candidate);
  };

  add(canonical);
  add(target);
  const variants = [
    ...doctypeVariants(canonical.doctype),
    ...doctypeVariants(target.doctype),
  ];
  for (const doctype of variants) {
    add({ module: canonical.module, doctype });
    const directAliases =
      DOCUMENT_ALIASES[`${canonical.module}/${normalizeDoctype(doctype)}`] ??
      [];
    for (const alias of directAliases) add(alias);
    for (const alias of resolveLegacyInvoiceOwnerAliases({
      module: canonical.module,
      doctype,
    })) {
      add(alias);
    }
  }

  return candidates;
}

function resolveLegacyInvoiceOwnerAliases(
  target: ActivityTarget
): ActivityTarget[] {
  if (target.module !== "accounting") return [];
  const normalized = normalizeDoctype(target.doctype);
  if (normalized === "invoice") {
    return [
      { module: "accounting", doctype: "sales_invoice" },
      { module: "accounting", doctype: "purchase_invoice" },
      { module: "accounting", doctype: "credit_note" },
      { module: "accounting", doctype: "purchase_credit_note" },
      { module: "accounting", doctype: "sales_debit_note" },
      { module: "accounting", doctype: "purchase_debit_note" },
      { module: "sales", doctype: "sales_invoice" },
      { module: "purchase", doctype: "purchase_invoice" },
      { module: "sales", doctype: "credit_note" },
      { module: "purchase", doctype: "credit_note" },
      { module: "sales", doctype: "sales_debit_note" },
      { module: "sales", doctype: "debit_note" },
      { module: "purchase", doctype: "debit_note" },
    ];
  }
  if (normalized === "sales_invoice")
    return [{ module: "sales", doctype: "sales_invoice" }];
  if (normalized === "purchase_invoice")
    return [{ module: "purchase", doctype: "purchase_invoice" }];
  if (normalized === "credit_note")
    return [
      { module: "accounting", doctype: "purchase_credit_note" },
      { module: "sales", doctype: "credit_note" },
      { module: "purchase", doctype: "credit_note" },
    ];
  if (normalized === "purchase_credit_note")
    return [{ module: "purchase", doctype: "credit_note" }];
  if (normalized === "debit_note")
    return [
      { module: "accounting", doctype: "sales_debit_note" },
      { module: "accounting", doctype: "purchase_debit_note" },
      { module: "sales", doctype: "sales_debit_note" },
      { module: "sales", doctype: "debit_note" },
      { module: "purchase", doctype: "debit_note" },
    ];
  if (normalized === "sales_debit_note")
    return [
      { module: "sales", doctype: "sales_debit_note" },
      { module: "sales", doctype: "debit_note" },
    ];
  if (normalized === "purchase_debit_note")
    return [{ module: "purchase", doctype: "debit_note" }];
  return [];
}

function doctypeVariants(doctype: string): string[] {
  const variants = new Set<string>();
  const normalized = normalizeDoctype(doctype);
  const hyphenated = normalized.replace(/_/g, "-");

  for (const value of [doctype, normalized, hyphenated]) {
    variants.add(value);
    variants.add(singularizeLastSegment(value));
    variants.add(pluralizeLastSegment(value));
  }

  if (normalized === "payment_receipt" || normalized === "payment_receipts") {
    variants.add("receipt");
    variants.add("receipts");
  }

  return [...variants];
}

function normalizeDoctype(doctype: string): string {
  return doctype.trim().replace(/-/g, "_");
}

function singularizeLastSegment(value: string): string {
  return transformLastSegment(value, (segment) => {
    if (segment.endsWith("ies") && segment.length > 3) {
      return `${segment.slice(0, -3)}y`;
    }
    if (
      segment.endsWith("s") &&
      !segment.endsWith("ss") &&
      segment.length > 1
    ) {
      return segment.slice(0, -1);
    }
    return segment;
  });
}

function pluralizeLastSegment(value: string): string {
  return transformLastSegment(value, (segment) => {
    if (segment.endsWith("s")) return segment;
    if (segment.endsWith("y") && segment.length > 1) {
      return `${segment.slice(0, -1)}ies`;
    }
    return `${segment}s`;
  });
}

function transformLastSegment(
  value: string,
  transform: (segment: string) => string
): string {
  const separator = value.includes("-") ? "-" : "_";
  const parts = value.split(separator);
  const last = parts.pop();
  if (!last) return value;
  return [...parts, transform(last)].join(separator);
}
